<script>

export default {
  name: 'LeaveConfirm',
  methods: {
    handleCloseDialog () {
      this.$emit('close')
      this.$emit('update:dialogVisible', false)
    },
    submit () {
      this.$emit('submit')
    }
  }
}
</script>

<template lang="pug" src="./LeaveConfirm.pug"></template>
